export default __webpack_public_path__ + "static/media/doctorHome.ff1d28a7.JPG";